<template lang="pug">
  transition(name="el-zoom-in-top")
    .content-wrapper
      <!-- Main content -->
      section(class="content")
        .box.citic-box
          the-page-header(page-title="小程序首页管理")
          .transfer-box
            .list-box.left
              .header
                h2 热门行业
              draggable.list(
                :list="listCategory"
                group="category"
                ghostClass="ghost"
                :sort="false")
                .option(
                  v-for="(item, index) in listCategory"
                )
                  strong {{item.categoryname}}
                  i {{item.dpnum}}
            .list-box.right
              .header
                h2 首页排序管理
              draggable.list(
                :list="listCategoryIndex"
                :animation=200
                :class="drag ? 'draging' : ''"
                group="category"
                ghostClass="ghost"
                @start="drag = true"
                @end="drag = false")
                transition-group(type="transition" :name="!drag ? 'flip-list' : null")
                  .option(
                    v-for="(item, index) in listCategoryIndex"
                    :key="index"
                  )
                    strong {{item.categoryname}}
                    i {{item.dpnum}}
          .ctrl-box
            el-button(type="primary" @click="handleUpdateIndex") 更新首页
      <!-- /.content -->
</template>

<script>
import draggable from 'vuedraggable'
import axios from 'axios'
import ThePageHeader from '../../partials/ThePageHeader'
export default {
  name: 'PostHome',
  components: {
    ThePageHeader,
    draggable
  },
  data () {
    return {
      drag: false,
      listCategory: [],
      listCategoryIndex: [],
      categoryIndexIdArray: []
    }
  },
  methods: {
    handleUpdateIndex () {
      let url = this.$config.API.mpIndex.update
      let data = {
        data: this.listCategoryIndex.map(item => {
          return item.category_id
        })
      }
      axios.post(url, data)
        .then(res => {
          console.log(res)
        })
    },
    getCurrentIndexCategories () {
      let url = this.$config.API.mpIndex.getIndex
      this.$http.get(url)
        .then(res => {
          if (res.data.result === 'success') {
            this.listCategoryIndex = res.data.categoryListObj.map(item => {
              let category = this.listCategory.find(element => {
                return element.category_id === item.CATEGORY_ID
              })
              if (category) {
                let obj = {
                  category_id: item.CATEGORY_ID,
                  categoryname: item.CATEGORY_NAME,
                  dpnum: category.dpnum
                }
                return obj
              }
            })
            this.listCategoryIndex = this.listCategoryIndex.filter(i => typeof (i) !== 'undefined')
            this.categoryIndexIdArray = this.listCategoryIndex.map(item => {
              return item.category_id
            })
            this.listCategory = this.listCategory.filter(item => this.categoryIndexIdArray.indexOf(item.category_id) === -1)
          }
        })
    }
  },
  mounted () {
    let url = this.$config.API.mpIndex.getCategory
    axios.get(url)
      .then(res => {
        if (res.data.result === 'success') {
          this.listCategory = res.data.categoryList
          this.getCurrentIndexCategories()
        }
      })
  }
}
</script>
<style lang="scss">
  .citic-box {
    padding-top: 15px;
    .el-tabs__content {
      overflow: visible !important;
      position: static;
    }
    .box-header {
      ul.nav-tabs {
        margin-bottom: 0 !important;
        border-bottom: 0;
        li > a {
          color: #9ebbcd !important;
        }
        li.active > a {
          color: #333 !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// home.vue?21d2449e